import Layout from '@/layout';
var mobileRouter = {
  path: '/organization',
  component: Layout,
  redirect: '/organization/supplier',
  name: 'organization',
  meta: {
    title: '组织管理',
    icon: 'user'
  },
  children: [
  // {
  //   path: '/organization/manage',
  //   component: () => import('@/views/organization/page.vue'),
  //   name: 'organization',
  //   meta: { title: '组织管理', icon: 'user' }
  // }
  {
    path: 'supplier',
    component: function component() {
      return import('@/views/organization/supplier-organization/page.vue');
    },
    name: 'supplierOrg',
    meta: {
      title: '品牌会员',
      icon: 'user'
    }
    // meta: { title: '供应商'}
  }, {
    path: 'exhibitorManagement',
    component: function component() {
      return import('@/views/organization/exhibitorManagement/page.vue');
    },
    name: 'exhibitorManagement',
    meta: {
      title: '展商管理',
      icon: 'user'
    }
  }, {
    path: 'OrgGifReview',
    component: function component() {
      return import('@/views/organization/gifReview-organization/page.vue');
    },
    name: 'OrgGifReview',
    meta: {
      title: '动图审核会员',
      icon: 'user'
    }
  }, {
    path: 'PlatformOperator',
    component: function component() {
      return import('@/views/organization/platform-operator/page.vue');
    },
    name: 'PlatformOperator',
    meta: {
      title: '平台经营者',
      icon: 'user'
    }
  }, {
    path: 'design',
    component: function component() {
      return import('@/views/organization/design-organization/page.vue');
    },
    name: 'designOrg',
    meta: {
      title: '企业会员',
      icon: 'user'
    }
  }, {
    path: 'procure',
    component: function component() {
      return import('@/views/organization/procure-organization/page.vue');
    },
    name: 'procureOrg',
    meta: {
      title: '小店伙伴',
      icon: 'user'
    }
  }, {
    path: 'propertyCompany',
    component: function component() {
      return import('@/views/organization/propertyCompany-organization/page.vue');
    },
    name: 'propertyCompanyOrg',
    meta: {
      title: '物业公司',
      icon: 'user'
    }
  }, {
    path: 'realEstatedEvelopers',
    component: function component() {
      return import('@/views/organization/realEstatedEvelopers-organization/page.vue');
    },
    name: 'realEstatedEvelopersOrg',
    meta: {
      title: '房产开发商',
      icon: 'user'
    }
  }, {
    path: 'propertyOperators',
    component: function component() {
      return import('@/views/organization/propertyOperators-organization/page.vue');
    },
    name: 'propertyOperatorsOrg',
    meta: {
      title: '楼盘运营商',
      icon: 'user'
    }
  }, {
    path: 'animationCompanies',
    component: function component() {
      return import('@/views/organization/animationCompanies-organization/page.vue');
    },
    name: 'animationCompaniesOrg',
    meta: {
      title: '制图会员',
      icon: 'user'
    }
  }, {
    path: 'guangzhouDesign',
    component: function component() {
      return import('@/views/organization/guangzhouDesign-organization/page.vue');
    },
    name: 'guangzhouDesign',
    meta: {
      title: '广州设计周',
      icon: 'user'
    }
  }, {
    path: 'partnerCity',
    component: function component() {
      return import('@/views/organization/partnerCity-organization/page.vue');
    },
    name: 'partnerCityOrg',
    meta: {
      title: '城市代理商',
      icon: 'user'
    }
  }, {
    path: 'smallStore',
    component: function component() {
      return import('@/views/organization/small-store/page.vue');
    },
    name: 'smallStore',
    meta: {
      title: '小店会员',
      icon: 'user'
    }
  }, {
    path: 'industryCompany',
    component: function component() {
      return import('@/views/organization/industry-company/page.vue');
    },
    name: 'industryCompany',
    meta: {
      title: '行业合伙人',
      icon: 'user'
    }
  }]
};
export default mobileRouter;